import { IUserActionTypes, eUserActionTypeIds } from "../../action-types/user/IUserActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IUserReducer } from "../../reducer-model/user/IUserReducer";
const iniState: IUserReducer = {
    selectedIds: [],
    status: eReducerStatusBase.is_not_initialization,
    users: [],
    user_editing: undefined
}
export const userReducer = (state: IUserReducer = iniState, action: IUserActionTypes): IUserReducer => {
    switch (action.type) {
        case eUserActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eUserActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                users: action.payload
            }
        case eUserActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                users: []
            }
        case eUserActionTypeIds.CHANGE_SELECTED_IDS:
            return {
                ...state,
                selectedIds: action.payload
            }
        case eUserActionTypeIds.SHOW_EDIT_MODAL:
            return {
                ...state,
                is_show_edit_modal: true,
                user_editing: action.payload
            }
        case eUserActionTypeIds.CLOSE_EDIT_MODAL:
            return {
                ...state,
                is_show_edit_modal: false,
                user_editing: undefined
            }
        case eUserActionTypeIds.SAVE_START:
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case eUserActionTypeIds.SAVE_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_saved
            }
        case eUserActionTypeIds.SAVE_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case eUserActionTypeIds.DELETE_START:
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case eUserActionTypeIds.DELETE_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_deleted
            }
        case eUserActionTypeIds.DELETE_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}